enum PageState {
    success = 200,
    badRequest = 400,
    unauthorized = 401,
    noPermission = 403,
    notFound = 404,
    serviceError = 500,
}

export default PageState;
